/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { ACTION_BUTTON_SIZE, ACTION_BUTTON_STYLE, ActionButton } from "../ActionButton";

export interface IViewErrorProps {
	onReload?: () => void;
}

export const ViewError = React.memo<IViewErrorProps>(({ onReload }) => {
	const baseClass = BEM("edt-view-error");

	baseClass.add("edt-base");

	return (
		<div className={baseClass.toClassName()}>
			<div className={baseClass.element("content").toClassName()}>
				<h2>Something went wrong</h2>
				<p>
					Unexpected error occured while loading the page. It may happen when your internet
					connection is offline or when our servers are temporarily unavailable. You can try to
					reload the page by clicking the button below. If problem persists please contact support.
				</p>
				<ActionButton
					label="Try Again"
					onClick={onReload}
					style={ACTION_BUTTON_STYLE.PRIMARY}
					size={ACTION_BUTTON_SIZE.LARGE}
				/>
			</div>
		</div>
	);
});

ViewError.displayName = "ViewError";
